import { useEffect, useState } from 'react';
import type { ForecastResult } from '@/domain';
import { forecastService } from '@/services/forecastService';
import { mockStore } from '@/lib/mock-store';
import { isMockBackend } from '@/lib/supabase';

export function useForecastResults(opts?: {
  warehouseId?: string;
  date?: string;
}): ForecastResult[] {
  const [rows, setRows] = useState<ForecastResult[]>([]);
  useEffect(() => {
    let alive = true;
    function refresh() {
      forecastService.list(opts).then((data) => {
        if (alive) setRows(data);
      });
    }
    refresh();
    if (isMockBackend) return mockStore.subscribe(refresh);
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opts?.warehouseId, opts?.date]);
  return rows;
}
